const SVGNS = 'http://www.w3.org/2000/svg';
const DEFAULT_ACTIVE_COLOR = 'red';
const DEFAULT_INACTIVE_COLOR = 'black';
export default function Toggle(params) {
  const {
    value,
    innerMethods,
    data,
    highlightOnHover
  } = params;
  if (typeof params.value !== 'boolean') return null;
  let finalValue = value;
  const toggleCell = document.createElement('div');
  toggleCell.classList.add('w5-toggle-cell');
  if (highlightOnHover) {
    toggleCell.classList.add('w5-toggle-cell--highlight-rest');
    if (!finalValue) {
      toggleCell.classList.add('w5-toggle-cell--highlight-hover');
    } else {
      toggleCell.classList.remove('w5-toggle-cell--highlight-rest');
    }
  }
  const defaultSvg = createDefaultSvg();
  const getSvg = (innerMethods === null || innerMethods === void 0 ? void 0 : innerMethods.getSvg) || null;
  const finalSvg = getCustomSvg(finalValue, getSvg) || defaultSvg;
  let color = getColor(finalValue);
  if (!getSvg) finalSvg.setAttributeNS(null, 'fill', color);
  if (innerMethods !== null && innerMethods !== void 0 && innerMethods.onClick) {
    finalSvg.addEventListener('click', handleOnChange(toggleCell, finalSvg, finalValue, data, getSvg, innerMethods.onClick));
  }
  toggleCell.appendChild(finalSvg);
  updateToggledClass(toggleCell, finalValue);
  return toggleCell;
}
const createDefaultSvg = () => {
  const defaultSvg = document.createElementNS(SVGNS, 'svg');
  defaultSvg.setAttributeNS(null, 'class', 'w5-toggle-cell-default');
  defaultSvg.setAttributeNS(null, 'viewBox', '0 0 100 100');
  const circle = document.createElementNS(SVGNS, 'circle');
  circle.setAttributeNS(null, 'cx', '50');
  circle.setAttributeNS(null, 'cy', '50');
  circle.setAttributeNS(null, 'r', '40');
  defaultSvg.appendChild(circle);
  return defaultSvg;
};
const handleOnChange = (toggleCell, finalSvg, finalValue, data, getSvg, onClick) => {
  return event => {
    finalValue = !finalValue;
    updateToggledClass(toggleCell, finalValue);
    if (!getSvg) {
      const color = getColor(finalValue);
      finalSvg.setAttributeNS(null, 'fill', color);
    } else {
      finalSvg.remove();
      const finalCustomSvg = getCustomSvg(finalValue, getSvg);
      finalCustomSvg.addEventListener('click', handleOnChange(toggleCell, finalCustomSvg, finalValue, data, getSvg, onClick));
      toggleCell.appendChild(finalCustomSvg);
    }
    onClick(finalValue, data, event);
  };
};
const getColor = value => {
  return value ? DEFAULT_ACTIVE_COLOR : DEFAULT_INACTIVE_COLOR;
};
const getCustomSvg = (value, getSvg) => {
  if (!getSvg) return null;
  const customSvg = getSvg(value);
  const svgContainer = document.createElement('div');
  svgContainer.classList.add('w5-toggle-cell__svg-container');
  svgContainer.innerHTML = customSvg;
  return svgContainer;
};
const updateToggledClass = (toggleCell, value) => {
  value ? toggleCell.classList.add('w5-toggle-cell--toggled') : toggleCell.classList.remove('w5-toggle-cell--toggled');
};